export default __webpack_public_path__ + "static/media/Watch.dbdb3724.jpeg";